import Model, { attr } from '@ember-data/model';

class AnalyticsFeature extends Model {
  @attr('number', { defaultValue: 10 }) numberOfDashboards;

  get details() {
    return [
      { key: 'numberOfDashboards', label: 'Number of Dashboards', value: this.numberOfDashboards },
    ];
  }
}

export default AnalyticsFeature;
